import LoadEmptyPage from './LoadEmptyPage'

export default LoadEmptyPage
